<common-header [title]="title" [items]="items"></common-header>

<div class="content">
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <form role="form" [formGroup]="formEdit" (ngSubmit)="onSubmit()" #formObject="ngForm">
          <div class="card">
            <div class="card-body">
              <div class="form-row">
                <div class="form-group col-12 col-xl-4">
                  <app-common-input
                    [control]="this.formEdit.get('cuid')"
                    [label]="'CUID'"
                    [type]="InputType.text"
                    [formSubmitted]="formObject.submitted">
                  </app-common-input>
                </div>

                <div class="form-group col-12 col-sm-6 col-xl-4">
                  <app-common-input
                    [control]="this.formEdit.get('name')"
                    [label]="'Nombre'"
                    [type]="InputType.text"
                    [formSubmitted]="formObject.submitted">
                  </app-common-input>
                </div>
                <div class="form-group col-12 col-sm-6 col-xl-4">
                  <app-common-input
                    [control]="this.formEdit.get('secondaryName')"
                    [label]="'Nombre secundario'"
                    [type]="InputType.text"
                    [formSubmitted]="formObject.submitted">
                  </app-common-input>
                </div>

                <div class="form-group col-12 col-sm-6 col-xl-4">
                  <common-input-select
                    class="form-control-sm"
                    [label]="'Tipo de Caja'"
                    [list]="this.cashRegisterType"
                    (valueChanged)="changeCashRegisterType($event)"
                    formControlName="cashRegisterTypeId"></common-input-select>
                </div>
                <div *ngIf="showCM" class="form-group col-12 col-sm-6 col-xl-4">
                  <app-cm-combo
                    [onlyNotUsed]="true"
                    [cashRegisterId]="cashRegisterId"
                    [control]="formEdit.get('cashMachineId')"></app-cm-combo>
                </div>

                <div class="form-group col-12">
                  <app-common-input
                    [control]="this.formEdit.get('observations')"
                    [label]="'Observaciones'"
                    [type]="InputType.textarea">
                  </app-common-input>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <app-confirm-buttons (onCancel)="cancel()"></app-confirm-buttons>
            </div>
          </div>
          <!-- /.card -->
        </form>
      </div>
    </div>
    <!-- /.row -->
  </div>
  <!-- /.container-fluid -->
</div>
<!-- /.content -->
